/*
=========================================================
* Otis Kit PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Otis Kit PRO components
import MKBox from 'components/MKBox';

// Otis Kit PRO examples
import DefaultCounterCard from 'examples/Cards/CounterCards/DefaultCounterCard';

function StatsOnee() {
  return (
    <MKBox component="section" py={3} position="center">
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: 'auto' }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={5}
              title="Países"
              description="Tenemos presencia en Latinoamérica
"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard count={8} title="Años" description="Creciendo contigo" />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={17}
              suffix="+"
              title="Empresas"
              description="Desarrollan proyectos con nosotros"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default StatsOnee;
